<template>
  <div ref="dataSection">
      <p class="label d-inline text-nowrap">
        <span :class="this.inputClassScc">{{ inputValue }}</span>
        <i v-bind:class="arrow"></i>
      </p>
  </div>
</template>

<script>
  import FormatNumberService from "../../services/format-number-service";
  import VarianceNumberTypeService from "../../services/variance-number-type-service";
  export default {
    name: "result-column-with-arrow",
    props: {
      data: Object,
      allowOnlyIntegerNumber: Boolean,
      notRoundUp: Boolean,
      decimal: Number,
      displayType: String,
      headerStyle: Boolean,
      isExpense: Boolean,
      varianceAmount: Number
    },
    computed: {
      inputClassScc: function() {
        return Number(this.data.data) >= 0 ? this.headerStyle ? "header-style" : "" : this.headerStyle ? "header-style text-red" : "text-red";
      },
      inputValue: function() {
        if (this.displayType === "percentageDecimal") {
          if (this.notRoundUp) {
            return FormatNumberService.formatNumberPercentageWithDecimal(Number(this.data.data), this.decimal);
          }
          else {
            return FormatNumberService.formatNumberPercentage(Number(this.data.data));
          }
        }
        else {
          if (this.notRoundUp) {
            return FormatNumberService.formatNumberResultWithDecimal(Number(this.data.data), this.decimal)
          }
          else {
            return FormatNumberService.formatNumberResult(Number(this.data.data));
          }
        }
      },
      arrow: function() {
        if (this.data.varianceResult !== null) {
          return this.getCss(this.data.varianceResult, this.isExpense);
        }
        else {
          const result = VarianceNumberTypeService.varianceNumberType(this.data.varianceAmount);
          return this.getCss(result, this.isExpense);
        }
      }
    },
    methods: {
      getCss: function(varianceResult, isExpense) {
        switch(varianceResult) {
          case 1:
            return "icon-arrow-up gray-arrow-right";
          case 2:
            return this.isExpense ? "icon-arrow-up blue-electric-color" : "icon-arrow-up";
          case 3:
            return this.isExpense ? "icon-arrow-down green-color-success" : "icon-arrow-down";
        }
      }
    }
  }
</script>
